//Last Modified: 2024/03/27 10:18:08

export const horizontalStratification = {
    id: 'horizontalStratification',
    beforeDraw(chart, args, options) {

        if (options.strata.length !== options.pallete.length) throw new Error('Strata and pallete must have same length')
        const {
            ctx,
            chartArea: {
                top, left, width, height
            }
        } = chart

        const strata_height = options.scaleStrata * height
        const gutter = 0.5 * (height - strata_height) // ??

        let start = left
        for (let i = 0; i < options.strata.length; i++) {

            let rect_width = Math.round(options.strata[i] * width / options.truncatedMax)
            ctx.fillStyle = options.pallete[i]

            if ((start + rect_width) > (width + left)) { // We have to account for the initial start being 11px
                /* The purpose of this block is to chop off any strata that exceed
                the most RHS ticker. If truncatedMax is 25, and the first strata is 20
                then the second start value is 20*width/25+left. If the second strata
                is 20, then we have left + 20/25 + 20/25 > 25*width/25+left = 1*width+left
                 */
                rect_width = Math.ceil(Math.abs(width-start+left))
            }
            //console.log("start, rect_width", start, rect_width)
            ctx.fillRect(start, top + gutter, rect_width, strata_height)

            start = start + rect_width
            //console.log("width!, start!", width, left)

            if (Math.ceil(start) >= width + left) {
                break;
            }

        }

    }
}

export const verticalStratification = {
    id: 'verticalStratification',
    beforeDraw(chart, args, options) {

        if (options.strata.length !== options.pallete.length) throw new Error('Strata and pallete must have same length')

        const {
            ctx,
            chartArea: {
                bottom, left, width, height
            }
        } = chart

        const strata_width = options.scaleStrata * width
        const gutter = 0.5 * (width - strata_width)

        let start = bottom

        for (let i = 0; i < options.strata.length; i++) {

            let rect_height = Math.round(0.01 * options.strata[i] * height)
            ctx.fillStyle = options.pallete[i]

            start = start - rect_height

            ctx.fillRect(left + gutter, start, strata_width, rect_height)

        }

    }
}